import { useTranslation } from "react-i18next";

const GRADE_FILL = "#152339";
const SELECTED_RING = "#1E4AD9";

export default function ZubrotekaQuickFilters({
  categories = [],
  grades = [],
  selectedSubject = null,
  selectedGrade = null,
  onSubjectSelect,
  onGradeSelect,
}) {
  const { t } = useTranslation();

  if (categories.length === 0 && grades.length === 0) {
    return null;
  }

  return (
    <div className="mb-8">
      {categories.length > 0 && (
        <div className="flex flex-wrap gap-3 mb-6">
          {categories.map((category) => {
            const isActive =
              selectedSubject &&
              category.resolvedSubjects.includes(selectedSubject);

            return (
              <button
                key={category.id}
                type="button"
                onClick={() => onSubjectSelect?.(category)}
                aria-pressed={Boolean(isActive)}
                className="relative flex flex-col items-center justify-center w-[180px] h-[180px] max-[640px]:w-[calc((100%-24px)/3)] max-[640px]:h-auto max-[640px]:aspect-square rounded-2xl text-white focus:outline-none"
                style={{
                  backgroundColor: category.color,
                  boxShadow: isActive ? `0 0 0 3px ${SELECTED_RING}` : "none",
                }}
              >
                <img
                  src={category.icon}
                  alt=""
                  className="w-14 h-14 object-contain mb-1.5"
                  draggable={false}
                />
                <span className="text-base font-semibold text-center px-3 leading-tight">
                  {t(category.labelKey)}
                </span>
              </button>
            );
          })}
        </div>
      )}

      {grades.length > 0 && (
        <div>
          <h2 className="text-lg font-semibold mb-3" style={{ color: GRADE_FILL }}>
            {t("gradeLabel")}
          </h2>
          <div className="flex flex-wrap gap-4">
            {grades.map((grade) => {
              const isActive = selectedGrade === grade;
              return (
                <button
                  key={grade}
                  type="button"
                  onClick={() => onGradeSelect?.(grade)}
                  aria-pressed={isActive}
                  className="relative flex items-center justify-center w-[80px] h-[80px] max-[640px]:w-16 max-[640px]:h-16 rounded-full text-white text-base font-semibold focus:outline-none"
                  style={{
                    backgroundColor: GRADE_FILL,
                    outline: isActive ? `3px solid ${SELECTED_RING}` : "none",
                    outlineOffset: isActive ? "3px" : "0",
                  }}
                >
                  <span className="relative z-10 px-1 truncate">{grade}</span>
                  <span
                    aria-hidden
                    className="absolute inset-2 rounded-full border-2 border-white/10"
                  />
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
